module.exports = __webpack_public_path__ + "img/outgoing-call.b650d3a4.svg";